export const DICTIONARY_MENU_ID = 'dictionary_menu_id';

export const DICTIONARY_SERVICE_URL = window.__RUNTIME_CONFIG__.DICTIONARY_SERVICE_URL ?
    window.__RUNTIME_CONFIG__.DICTIONARY_SERVICE_URL : 'https://spellcheck.prod.rafifox.com';

export const IGNORED_WORDS_MAP_KEY = 'RAFI_IGNORED_MAP_WORDS';
